
export interface AnalyticsContent {
    event: string;
    link?: {
        name: string;
        type: string;
        location: string;
        destinationUrl: string;
    };
    page?: {
        experienceType: string,
        is404: boolean,
        lang: string,
        name: string,
        sitesection1: string,
        sitesection2: string,
        sitesection3: string,
        sitesection4: string,
        test: string,
        group: string,
        referringSite: string, //populated on landing page, when the user is coming from a different portal which is internal to UHG e.g. myuhc, laww, etc. For SSO OR manual sign-in scenarios, the correct value should be carried forward
        customAttributes: {
        }
    };
    user?: {
        loginStatus: string,
        userType: string,
        groupId: string,
        carrierId: string,
        hsid: string, // Populate the HSID Value of the logged in user
        enterpriseId: string,// EID, also known as Master Individual ID. Generated by the Enterprise Individual Mastering Platform (EiMP)
        rallyId: string,
        payerGroup: string,
        accountId: string
    };

    form?: {
        name:string,
        step:string
    };
    modal?: {
        name:string
    };
    error?: {
        message: string,
        source: string,
        code: string,
        subtype: string,
        customAttributes: object
    }
}

export function pageTrackEvent(pageContent: AnalyticsContent['page'],): void {
    let content ={
        event: 'page track',
            page: pageContent,
        user:  {
            loginStatus: "not logged in",
            userType:  "" ,
            groupId: "",
            carrierId: "",
            hsid: "",
            enterpriseId: "",
            rallyId: "",
            payerGroup: "",
            accountId: ""
    }
    }
    console.log('Page Track Event:', content);
    window.adobeDataLayer.push(content);
}

export function linkTrackEvent(linkName: string, linkLocation: string, linkType:string, destinationUrl:string = "" ) : void {
    let content = {
        event: 'link track',
        link: {
            name: linkName,
            location: linkLocation,
            type: linkType,
            destinationUrl: destinationUrl.toLowerCase()
        }
    };
    console.log('Link Track Event:',  content, content.link);
    window.adobeDataLayer.push(content);
};

export function formStartedEvent(): void {
    let content ={
        event: 'form started',
        form: {
            name: "open hsa"
        }
    }
    console.log('Form Started Event', content);
    window.adobeDataLayer.push(content);
}

export function formStepEvent(step: string): void {
    let content ={
        event: 'form step',
        form: {
            name: "open hsa",
            step: step
        }
    } ;
    console.log('Form Step Event:', content);
    window.adobeDataLayer.push(content);
}

export function modalTrackEvent(modalName: string): void {
    let content ={
        event: 'modal track',
        modal: {
            name: modalName
        }
    } ;
    console.log('Modal Track Event:', content);
    window.adobeDataLayer.push(content);
}

export function formCompleteEvent(): void {
    let content = {
        event: 'form complete',
        form: {
            name: "open hsa"
        }
    };
    console.log('Form Complete Event', content);
    window.adobeDataLayer.push(content);
}

export function funcErrorEvent(errorMessage: string,
                               code: string,
                               subtype: string,
                               customAttributes: object): void {
    let content ={
        event: 'func error',
        error: {
            message: errorMessage.toLowerCase(),
            source: "open hsa form",
            code: code,
            subtype: subtype,
            customAttributes: customAttributes
        }
    } ;
    console.log('Function Error Event:', content);
    window.adobeDataLayer.push(content);
}

